import { useConfiguratorStore } from '@ui/features/configurator/hooks/use-configurator-store';
import { getFieldLabel } from '@ui/features/configurator/store/helpers/get-field-label';
import type { ConfiguratorFieldType } from '@ui/features/configurator/types';

/**
 * The label and tooltip to render for a field, carrying any unit its
 * configuration could not state up front.
 */
export function useFieldLabel(field: ConfiguratorFieldType) {
  const state = useConfiguratorStore();

  return getFieldLabel(field, state);
}
